import { PlaceholderValue } from "./PlaceholderValue";

const TextValue = ({ className, value }: { className?: string; value?: string }) => {
  if (!value) {
    return <PlaceholderValue />;
  }

  return <span className={className}>{value}</span>;
};

export { TextValue };
